import { createRouter, createWebHistory } from "vue-router";
import { CargoPickupPage} from "@/pages/";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    component: CargoPickupPage
  }
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
